/**
 * Calculate min and max date range for visit booking
 *
 * Reference: https://theplanttokyo.atlassian.net/browse/VHM-752?focusedCommentId=265839
 * - 「3 days after the date of submission」 to 「2 weeks later counting from 3 days after the date of submission」
 * - 「the earliest available date for visit」to「2 weeks after the earliest available date for visit」
 * - If the 「earliest available date for visit」 is earlier than 「3 days after the date of submission」, then please use 「3 days after the date of submission」
 */
export function getVisitDateRange(date?: Date | null): {
  minDate: string;
  maxDate: string;
} {
  const threeDaysLater = new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);
  let minDate: string;
  let maxDate: string;

  if (date && date > threeDaysLater) {
    minDate = date.toISOString().slice(0, 10).replaceAll("-", "/");
    const maxDateObj = new Date(date);
    maxDateObj.setDate(maxDateObj.getDate() + 14);
    maxDate = maxDateObj.toISOString().slice(0, 10).replaceAll("-", "/"); // +14 days
  } else {
    minDate = threeDaysLater.toISOString().slice(0, 10).replaceAll("-", "/"); // +3 days
    maxDate = new Date(Date.now() + 17 * 24 * 60 * 60 * 1000)
      .toISOString()
      .slice(0, 10)
      .replaceAll("-", "/"); // +17 days
  }

  return { minDate, maxDate };
}
